import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PrivateChannelIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' {...props} ref={ref} data-testid='private_channel_icon'>
        <path fill='currentColor' d='M15 16.667v-7.5H5v7.5h10zM15 7.5c.917 0 1.667.75 1.667 1.667v7.5c0 .916-.75 1.666-1.667 1.666H5c-.917 0-1.667-.75-1.667-1.666v-7.5C3.333 8.25 4.083 7.5 5 7.5h.833V5.833A4.126 4.126 0 0110 1.667a4.126 4.126 0 014.167 4.166V7.5H15zm-5-4.167c-1.416 0-2.5 1.084-2.5 2.5V7.5h5V5.833c0-1.416-1.083-2.5-2.5-2.5z' />
    </svg>
));
